var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"text-body-1 rounded-lg",attrs:{"accordion":"","focusable":""},model:{value:(_vm.activePanel),callback:function ($$v) {_vm.activePanel=$$v},expression:"activePanel"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }